var types = {};
var hasRequiredTypes;
function requireTypes() {
  if (hasRequiredTypes) return types;
  hasRequiredTypes = 1;
  Object.defineProperty(types, "__esModule", {
    value: true
  });
  types.SKELETON_TYPE = types.TYPE = void 0;
  types.isLiteralElement = isLiteralElement;
  types.isArgumentElement = isArgumentElement;
  types.isNumberElement = isNumberElement;
  types.isDateElement = isDateElement;
  types.isTimeElement = isTimeElement;
  types.isSelectElement = isSelectElement;
  types.isPluralElement = isPluralElement;
  types.isPoundElement = isPoundElement;
  types.isTagElement = isTagElement;
  types.isNumberSkeleton = isNumberSkeleton;
  types.isDateTimeSkeleton = isDateTimeSkeleton;
  types.createLiteralElement = createLiteralElement;
  types.createNumberElement = createNumberElement;
  var TYPE;
  (function (TYPE) {
    /**
     * Raw text
     */
    TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */
    TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */
    TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */
    TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */
    TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */
    TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */
    TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */
    TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */
    TYPE[TYPE["tag"] = 8] = "tag";
  })(TYPE || (types.TYPE = TYPE = {}));
  var SKELETON_TYPE;
  (function (SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
  })(SKELETON_TYPE || (types.SKELETON_TYPE = SKELETON_TYPE = {}));
  /**
   * Type Guards
   */
  function isLiteralElement(el) {
    return el.type === TYPE.literal;
  }
  function isArgumentElement(el) {
    return el.type === TYPE.argument;
  }
  function isNumberElement(el) {
    return el.type === TYPE.number;
  }
  function isDateElement(el) {
    return el.type === TYPE.date;
  }
  function isTimeElement(el) {
    return el.type === TYPE.time;
  }
  function isSelectElement(el) {
    return el.type === TYPE.select;
  }
  function isPluralElement(el) {
    return el.type === TYPE.plural;
  }
  function isPoundElement(el) {
    return el.type === TYPE.pound;
  }
  function isTagElement(el) {
    return el.type === TYPE.tag;
  }
  function isNumberSkeleton(el) {
    return !!(el && typeof el === 'object' && el.type === SKELETON_TYPE.number);
  }
  function isDateTimeSkeleton(el) {
    return !!(el && typeof el === 'object' && el.type === SKELETON_TYPE.dateTime);
  }
  function createLiteralElement(value) {
    return {
      type: TYPE.literal,
      value: value
    };
  }
  function createNumberElement(value, style) {
    return {
      type: TYPE.number,
      value: value,
      style: style
    };
  }
  return types;
}

export { requireTypes as r };
//# sourceMappingURL=types-DHzUeLq8-C0BjbYwq.js.map
